import { useModalContext } from 'utils/contexts/modal';
import { OrganizationEditModal } from './OrganizationEditModal';
import { OrganizationSyncEditModal } from './OrganizationSyncEditModal';
import type { AllOrganizationsModalState } from '../types';

export const AllOrganizationsModals = () => {
  const { modalState, hideModal } = useModalContext<AllOrganizationsModalState>();
  if (modalState === null) return null;

  const { action } = modalState;

  switch (action) {
    case 'organizationEditModal':
      return <OrganizationEditModal orgId={modalState.orgId} onClose={hideModal} />;
    case 'organizationSyncEditModal':
      return <OrganizationSyncEditModal onClose={hideModal} />;
    default:
      return null;
  }
};
